/* eslint-disable react/jsx-props-no-spreading */
import { FC, useMemo } from 'react'
import { Card, Spin } from 'antd'
import { Pie } from '@ant-design/plots'
import beautifulPieConfig from 'utils/pieConfigBuilder'
import { useAppSelector } from 'hooks/reduxHooks'
import { isEqual } from 'lodash'
import { BroadcastStatus } from 'types'

const beautifulConfig = beautifulPieConfig<number>({
	contentHint: data =>
		data.reduce((sum, curr) => sum + curr.value, 0).toString(),
})

const getBroadcastStatusName = (status: BroadcastStatus) => {
	switch (status) {
		case 'DRAFT':
			return 'Draft'
		case 'SCHEDULED':
			return 'Scheduled'
		case 'COMPLETED':
			return 'Completed'
		case 'CANCELED':
			return 'Canceled'
		case 'IN_PROCESS':
			return 'In Process'
		default:
			return 'Unknown'
	}
}

const BroadcastsOverview: FC = () => {
	const { views, viewsLoading: loading } = useAppSelector(
		state => state.broadcasts,
		isEqual
	)

	const data = useMemo(
		() =>
			views
				? Object.keys(views).map((status: string) => ({
						type: getBroadcastStatusName(status as BroadcastStatus),
						value: views[status as keyof typeof views] ?? 0,
				  }))
				: [
						{
							type: 'Draft',
							value: 0,
						},
						{
							type: 'Scheduled',
							value: 0,
						},
						{
							type: 'Completed',
							value: 0,
						},
						{
							type: 'Canceled',
							value: 0,
						},
						{
							type: 'In Process',
							value: 0,
						},
				  ],
		[views]
	)

	return (
		<Spin spinning={loading}>
			<Card title='Broadcasts Overview'>
				<Pie
					{...beautifulConfig
						.size({
							height: 250,
						})
						.data(data)
						.build()}
				/>
			</Card>
		</Spin>
	)
}

export default BroadcastsOverview
